import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/download-icon.svg'
import _imports_1 from '@/assets/plus.svg'


const _withScopeId = n => (_pushScopeId("data-v-e17972ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-declarationAcceptance",
  class: "container step--declaration-acceptance"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = { class: "fs-11" }
const _hoisted_4 = { class: "row--person-politically-exposed__row__disclaimer-link" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "criminal-statement" }
const _hoisted_8 = { class: "warning" }
const _hoisted_9 = { class: "fs-11" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_11 = ["onSubmit"]
const _hoisted_12 = { class: "row--us-taxpayer" }
const _hoisted_13 = { class: "row--us-taxpayer__row" }
const _hoisted_14 = { class: "row--us-taxpayer__question" }
const _hoisted_15 = { class: "row--person-politically-exposed__moreInfo" }
const _hoisted_16 = { class: "row--us-taxpayer__choice" }
const _hoisted_17 = {
  key: 0,
  class: "row--us-taxpayer__tin"
}
const _hoisted_18 = { class: "row--person-politically-exposed" }
const _hoisted_19 = { class: "row--person-politically-exposed__row" }
const _hoisted_20 = { class: "row--person-politically-exposed__question" }
const _hoisted_21 = { class: "row--person-politically-exposed__moreInfo" }
const _hoisted_22 = { class: "row--person-politically-exposed__choice" }
const _hoisted_23 = { class: "row--data-user" }
const _hoisted_24 = { class: "row--data-user__row" }
const _hoisted_25 = { class: "row--data-user__question" }
const _hoisted_26 = { class: "row--data-user__moreInfo" }
const _hoisted_27 = { class: "row--data-user__choice" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "row--data-user" }
const _hoisted_30 = { class: "row--data-user__row" }
const _hoisted_31 = { class: "row--data-user__question" }
const _hoisted_32 = { class: "row--data-user__choice" }
const _hoisted_33 = {
  key: 0,
  class: "row--data-user"
}
const _hoisted_34 = { class: "row--data-user__row" }
const _hoisted_35 = { class: "row--data-user__question" }
const _hoisted_36 = { class: "row--data-user__choice" }
const _hoisted_37 = { class: "row__data-information" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "container__subheader t-bold t-center" }
const _hoisted_40 = { class: "row--data-user" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row--acceptance-of-documents__annotation t-bold" }, null, -1))
const _hoisted_42 = { class: "container__subheader t-bold t-center" }
const _hoisted_43 = { class: "row--acceptance-of-documents declaration-step-checkbox-wrapper" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  class: "row--documents",
  "cy-data": "document-list"
}
const _hoisted_46 = { class: "download-all-link" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "download-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "row--acceptance-of-documents declaration-step-checkbox-wrapper" }
const _hoisted_50 = {
  class: "row--documents",
  "cy-data": "document-list"
}
const _hoisted_51 = { class: "download-all-link" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "download-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_53 = { class: "row--acceptance-of-documents__label" }
const _hoisted_54 = { class: "row--acceptance-of-documents__label" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = ["aria-expanded"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_58 = ["href", "tabindex"]
const _hoisted_59 = ["href", "tabindex"]
const _hoisted_60 = ["href", "tabindex"]
const _hoisted_61 = ["href", "tabindex"]
const _hoisted_62 = ["href", "tabindex"]
const _hoisted_63 = ["href", "tabindex"]
const _hoisted_64 = ["href", "tabindex"]
const _hoisted_65 = ["href", "tabindex"]
const _hoisted_66 = ["href"]
const _hoisted_67 = ["href", "tabindex"]
const _hoisted_68 = ["href", "tabindex"]
const _hoisted_69 = ["href", "tabindex"]
const _hoisted_70 = ["href", "tabindex"]
const _hoisted_71 = ["href", "tabindex"]
const _hoisted_72 = ["href", "tabindex"]
const _hoisted_73 = ["href", "tabindex"]
const _hoisted_74 = ["href", "tabindex"]
const _hoisted_75 = ["href", "tabindex"]
const _hoisted_76 = ["href", "tabindex"]
const _hoisted_77 = ["href", "tabindex"]
const _hoisted_78 = ["href"]
const _hoisted_79 = { class: "row--acceptance-of-documents__annotation t-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_Field = _resolveComponent("Field")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.statements`)), 1),
    _createVNode(_component_Popup, {
      "is-open": _ctx.isOpenInformationForUsTaxPayer,
      "cy-data": "popup-us-tax-payer",
      onButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupHandle('usTaxPayerPopup')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.fatcaDisclaimer`)), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.usTaxPayerInformation`)), 1)
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_Popup, {
      "is-open": _ctx.isOpenInformationForPoliticallyExposedPerson,
      "cy-data": "popup-pep",
      class: "popup--pep",
      onButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupHandle('politicallyExposedPersonPopup')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.politicallyExposedPersonDisclaimer`)), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: 
                            _ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.politicallyExposedPersonFile`
                            )
                        ,
              rel: "noopener",
              target: "_blank"
            }, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.politicallyExposedPersonFileText`
                            )) + ", ", 9, _hoisted_5)
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.potentialPeoplesCriminalStatement`
                        )), 1),
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.politicallyExposedPersonInformationHeader`
                        )), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesOne`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesTwo`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesThree`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesFour`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesFive`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesSix`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesSeven`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesEight`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesNine`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesTen`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesEleven`)), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesTwelve`)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.potentialPeoplesWarning`)), 1)
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_Popup, {
      "is-open": _ctx.isOpenDataUserDeclarationInfo,
      "cy-data": "popup-data-user-declaration-open",
      onButtonClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenDataUserDeclarationInfo = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.dataUserDeclarationTooltipHeaderInfoOne`
                        )), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.dataUserDeclarationTooltipHeaderInfoTwo`
                        )), 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.nonProfessional`)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.dataUserDeclarationNonProfessionalInfo`
                        )), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.dataUserDeclarationNonProfessionalInfoHeader`
                        )), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.dataUserDeclarationNonProfessionalInfoOne`
                            )), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.dataUserDeclarationNonProfessionalInfoTwo`
                            )), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.dataUserDeclarationNonProfessionalInfoThree`
                            )), 1)
          ]),
          _hoisted_10,
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.professional`)), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.dataUserDeclarationProfessionalInfo`
                            )), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("form", {
      autocomplete: "off",
      style: _normalizeStyle({
                display:
                    _ctx.isOpenInformationForUsTaxPayer ||
                    _ctx.isOpenInformationForPoliticallyExposedPerson ||
                    _ctx.isOpenDataUserDeclarationInfo
                        ? 'none'
                        : 'block',
            }),
      onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.isUsTaxPayer`)), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", {
              ref: "usTaxPayerMoreInormation",
              class: "row--us-taxpayer__more-info",
              "data-info": "usTaxPayerPopup",
              "cy-data": "popup-us-tax-payer-open",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popupHandle('usTaxPayerPopup')))
            }, " ? ", 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.no`),
            name: "usaTaxPayer",
            value: false,
            checked: _ctx.formData.usaTaxPayer === false,
            "handles-error": false,
            "cy-data": "us-tax-payer-no",
            onUpdateValue: _cache[4] || (_cache[4] = 
                            ($event) => (_ctx.formData.usaTaxPayer = $event)
                        )
          }, null, 8, ["label", "checked"]),
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.yes`),
            name: "usaTaxPayer",
            value: true,
            checked: _ctx.formData.usaTaxPayer === true,
            "cy-data": "us-tax-payer-yes",
            onUpdateValue: _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.usaTaxPayer = $event))
          }, null, 8, ["label", "checked"])
        ]),
        (_ctx.formData.usaTaxPayer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_Field, {
                modelValue: _ctx.formData.usaTin,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.usaTin = $event)),
                type: "text",
                name: "usaTin",
                "cy-data": "us-tax-payer-tin",
                placeholder: 
                            _ctx.$t(`${_ctx.TRANSLATION_KEY}.usaTinPlaceholder`)
                        ,
                "is-numeric": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.usaTinLabel`)), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.politicallyExposedPerson`)), 1),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", {
              ref: "politicallyExposedPersonMoreInormation",
              class: "row--person-politically-exposed__more-info",
              "data-info": "politicallyExposedPersonPopup",
              "cy-data": "popup-pep-open",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (
                                _ctx.popupHandle('politicallyExposedPersonPopup')
                            ))
            }, " ? ", 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.no`),
            name: "pepDeclaration",
            value: false,
            checked: _ctx.formData.pepDeclaration === false,
            "handles-error": false,
            "cy-data": "pep-no",
            onUpdateValue: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.pepDeclaration = $event))
          }, null, 8, ["label", "checked"]),
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.yes`),
            name: "pepDeclaration",
            value: true,
            checked: _ctx.formData.pepDeclaration === true,
            "cy-data": "pep-yes",
            onUpdateValue: _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.pepDeclaration = $event))
          }, null, 8, ["label", "checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.dataUserDeclaration`)), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", {
              ref: "dataUserDeclarationMoreInfo",
              class: "row--data-user__more-info",
              "data-info": "dataUserDeclarationPopup",
              "cy-data": "popup-data-user-declaration-open",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isOpenDataUserDeclarationInfo = true))
            }, " ? ", 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.nonProfessional`),
            name: "dataUserDeclaration",
            value: _ctx.DataUserDeclaration.NON_PROFESSIONAL,
            checked: 
                            _ctx.formData.dataUserDeclaration ===
                            _ctx.DataUserDeclaration.NON_PROFESSIONAL
                        ,
            "handles-error": false,
            "cy-data": "data-user-declarationnon-professional",
            onUpdateValue: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.dataUserDeclaration = $event))
          }, null, 8, ["label", "value", "checked"]),
          _createVNode(_component_Radio, {
            label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.professional`),
            name: "dataUserDeclaration",
            value: _ctx.DataUserDeclaration.PROFESSIONAL,
            checked: 
                            _ctx.formData.dataUserDeclaration ===
                            _ctx.DataUserDeclaration.PROFESSIONAL
                        ,
            "cy-data": "data-user-declaration-professional",
            onUpdateValue: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.dataUserDeclaration = $event))
          }, null, 8, ["label", "value", "checked"])
        ])
      ]),
      (_ctx.isStocksAccountType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgQuestionFirst`)), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_Radio, {
                  label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.yes`),
                  name: "esgQuestionFirst",
                  value: _ctx.EsgQuestionFirst.INVESTMENTS_YES,
                  checked: 
                                _ctx.formData.esgQuestionFirst ===
                                _ctx.EsgQuestionFirst.INVESTMENTS_YES
                            ,
                  "handles-error": false,
                  "cy-data": "data-user-esg-question-first-yes",
                  onUpdateValue: _ctx.handleEsgQuestionFirstUpdate
                }, null, 8, ["label", "value", "checked", "onUpdateValue"]),
                _createVNode(_component_Radio, {
                  label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.no`),
                  name: "esgQuestionFirst",
                  value: _ctx.EsgQuestionFirst.INVESTMENTS_NO,
                  checked: 
                                _ctx.formData.esgQuestionFirst ===
                                _ctx.EsgQuestionFirst.INVESTMENTS_NO
                            ,
                  "cy-data": "data-user-esg-question-first-no",
                  onUpdateValue: _ctx.handleEsgQuestionFirstUpdate
                }, null, 8, ["label", "value", "checked", "onUpdateValue"])
              ])
            ]),
            (
                        _ctx.formData.esgQuestionFirst ===
                        _ctx.EsgQuestionFirst.INVESTMENTS_YES
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgQuestionSecond`)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_Radio, {
                      label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.yes`),
                      name: "esgQuestionSecond",
                      value: _ctx.EsgQuestionSecond.LIMITED_YES,
                      checked: 
                                _ctx.formData.esgQuestionSecond ===
                                _ctx.EsgQuestionSecond.LIMITED_YES
                            ,
                      "handles-error": false,
                      "cy-data": "data-user-esg-question-second-yes",
                      onUpdateValue: _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.esgQuestionSecond = $event))
                    }, null, 8, ["label", "value", "checked"]),
                    _createVNode(_component_Radio, {
                      label: _ctx.$t(`${_ctx.TRANSLATION_KEY}.no`),
                      name: "esgQuestionSecond",
                      value: _ctx.EsgQuestionSecond.LIMITED_NO,
                      checked: 
                                _ctx.formData.esgQuestionSecond ===
                                _ctx.EsgQuestionSecond.LIMITED_NO
                            ,
                      "cy-data": "data-user-esg-question-second-no",
                      onUpdateValue: _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.esgQuestionSecond = $event))
                    }, null, 8, ["label", "value", "checked"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgDisclaimerHeader`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgDisclaimerItemOne`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgDisclaimerItemTwo`)), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgDisclaimerFooter`)), 1)
            ]),
            (
                        _ctx.isStocksAccountType &&
                        _ctx.formData.esgQuestionFirst ===
                            _ctx.EsgQuestionFirst.INVESTMENTS_YES &&
                        _ctx.formData.esgQuestionSecond ===
                            _ctx.EsgQuestionSecond.LIMITED_NO
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgQuestionFailureInfo`)), 1),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_CheckBox, {
                      modelValue: _ctx.formData.esgQuestionFailure,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.esgQuestionFailure = $event)),
                      name: "esgQuestionFailure",
                      "is-validated": false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.esgQuestionFailure`)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _hoisted_41,
                  _createVNode(_component_SubmitButton, {
                    action: _ctx.Action.DECLARATION_ACCEPTANCE,
                    "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.esgSubmit`),
                    data: _ctx.formData,
                    class: "button button--submit",
                    disabled: 
                            !_ctx.formEsgFailedValid || !_ctx.formData.esgQuestionFailure
                        ,
                    onClick: _ctx.handleNextStep
                  }, null, 8, ["action", "button-value", "data", "disabled", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.formEsgFailedValid && 'blur-div-wrapper'])
      }, [
        _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.agreementsHeader`)), 1),
        _createElementVNode("div", _hoisted_43, [
          (_ctx.isStocksAccountType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_CheckBox, {
                      modelValue: _ctx.formData.downloadAll,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.downloadAll = $event)),
                      name: "downloadAll",
                      value: false,
                      "is-validated": false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                                            `${_ctx.TRANSLATION_KEY}.downloadAllStock`
                                        )), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isStocksAccountType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createVNode(_component_CheckBox, {
                          modelValue: _ctx.formData.downloadAll,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.downloadAll = $event)),
                          name: "downloadAll",
                          value: false,
                          "is-validated": false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(
                                                    `${_ctx.TRANSLATION_KEY}.downloadAll`
                                                )), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isStocksAccountType)
            ? (_openBlock(), _createBlock(_component_CheckBox, {
                key: 2,
                modelValue: _ctx.formData.statementReceiveStocksKid,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formData.statementReceiveStocksKid = $event)),
                name: "statementReceiveStocksKid",
                value: false,
                "cy-data": "received-kid",
                text: "$t(`${TRANSLATION_KEY}.statementReceiveStocksKid`)"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    ref: "statementReceiveStocksKid",
                    class: "row--acceptance-of-documents__label"
                  }, _toDisplayString(_ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.statementReceiveStocksKid`
                                )), 513)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CheckBox, {
            modelValue: _ctx.formData.documentsAcceptance,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formData.documentsAcceptance = $event)),
            name: "documentsAcceptance",
            value: false,
            "cy-data": "accept-documents"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.acceptanceOfDocuments`)), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.consents.includes('RECEIVED_KID'))
            ? (_openBlock(), _createBlock(_component_CheckBox, {
                key: 3,
                modelValue: _ctx.formData.receivedKid,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formData.receivedKid = $event)),
                name: "receivedKid",
                value: false,
                "cy-data": "received-kid",
                text: "$t(`${TRANSLATION_KEY}.receivedKid`)"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    ref: "receivedKidRef",
                    class: "row--acceptance-of-documents__label"
                  }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.receivedKid`)), 513)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (
                            _ctx.consents.includes('UNDERSTOOD_FEATURES_AND_RISKS')
                        )
            ? (_openBlock(), _createBlock(_component_CheckBox, {
                key: 4,
                modelValue: _ctx.formData.understoodFeaturesAndRisks,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.formData.understoodFeaturesAndRisks = $event)),
                name: "understoodFeaturesAndRisks",
                value: false,
                "cy-data": "understood-features"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    ref: "understoodFeaturesRisksRef",
                    class: "row--acceptance-of-documents__label"
                  }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.understoodFeaturesRisks`)), 513)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (
                            _ctx.consents.includes('AWARE_OF_LOSS_AND_CREDIT_RISKS')
                        )
            ? (_openBlock(), _createBlock(_component_CheckBox, {
                key: 5,
                modelValue: _ctx.formData.awareOfLossAndCreditRisks,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.formData.awareOfLossAndCreditRisks = $event)),
                name: "awareOfLossAndCreditRisks",
                value: false,
                "cy-data": "aware-of-loss"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    ref: "awareOfLossRisksRef",
                    class: "row--acceptance-of-documents__label"
                  }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.awareOfLossRisks`)), 513)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.otherThanPLAndEN())
            ? (_openBlock(), _createBlock(_component_CheckBox, {
                key: 6,
                modelValue: _ctx.formData.confirmEnglishKnowledgeAgreement,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.formData.confirmEnglishKnowledgeAgreement = $event)),
                name: "confirmEnglishKnowledgeAgreement",
                value: false,
                "cy-data": "confirm-english-knowledge-agreement",
                class: "m-bottom"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t(
                                    `${_ctx.TRANSLATION_KEY}.acceptanceOfEnglishKnowledgeAgreementLabel`
                                )), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass([
                            'row--show-documents',
                            _ctx.showDocuments && 'active',
                        ]),
            "aria-expanded": _ctx.showDocuments,
            "aria-controls": "declaration-documents-list",
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.documentsShow && _ctx.documentsShow(...args)))
          }, [
            _hoisted_57,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.showAllDocuments`)), 1)
          ], 10, _hoisted_56)
        ]),
        (_ctx.isStocksAccountType)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "declaration-documents-list",
              class: _normalizeClass([
                        'document-list',
                        _ctx.showDocuments && 'document-list-show',
                    ])
            }, [
              _createElementVNode("a", {
                href: 
                            _ctx.$t(`${_ctx.TRANSLATION_KEY}.documentInformationCardFile`)
                        ,
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.documentInformationCard`)), 9, _hoisted_58),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.termsOfServiceFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.termsOfService`)), 9, _hoisted_59),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.frameworkAgreementFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.frameworkAgreement`)), 9, _hoisted_60),
              _createElementVNode("a", {
                href: 
                            _ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.stocksSupplementFrameworkAgreementLink`
                            )
                        ,
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.stocksSupplementFrameworkAgreement`
                            )), 9, _hoisted_61),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.financialInstrumentFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.financialInstrument`)), 9, _hoisted_62),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.costsTablesStocksFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.costsTablesStocks`)), 9, _hoisted_63),
              _createElementVNode("a", {
                href: 
                            _ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.financialInstumentsSpecificationFileStocks`
                            )
                        ,
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.financialInstumentsSpecificationStocks`
                            )), 9, _hoisted_64),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.orderExecutionOrderFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.orderExecutionOrder`)), 9, _hoisted_65),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.exAnteFileStocks`),
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.exAnteStocks`)), 9, _hoisted_66)
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: "declaration-documents-list",
              class: _normalizeClass([
                        'document-list',
                        _ctx.showDocuments && 'document-list-show',
                    ])
            }, [
              _createElementVNode("a", {
                href: 
                            _ctx.$t(`${_ctx.TRANSLATION_KEY}.documentInformationCardFile`)
                        ,
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.documentInformationCard`)), 9, _hoisted_67),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.termsOfServiceFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.termsOfService`)), 9, _hoisted_68),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.frameworkAgreementFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.frameworkAgreement`)), 9, _hoisted_69),
              _createElementVNode("a", {
                href: 
                            _ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.cfdsSupplementFrameworkAgreementLink`
                            )
                        ,
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.cfdsSupplementFrameworkAgreement`
                            )), 9, _hoisted_70),
              _createElementVNode("a", {
                href: 
                            _ctx.$t(`${_ctx.TRANSLATION_KEY}.keyProductInformationFile`)
                        ,
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.keyProductInformation`)), 9, _hoisted_71),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.financialInstrumentFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.financialInstrument`)), 9, _hoisted_72),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.costsTablesFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.costsTables`)), 9, _hoisted_73),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.rollTableInstumentsFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.rollTableInstuments`)), 9, _hoisted_74),
              _createElementVNode("a", {
                href: 
                            _ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.financialInstumentsSpecificationFile`
                            )
                        ,
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(
                                `${_ctx.TRANSLATION_KEY}.financialInstumentsSpecification`
                            )), 9, _hoisted_75),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.orderExecutionOrderFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.orderExecutionOrder`)), 9, _hoisted_76),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.swapTableFile`),
                tabindex: _ctx.showDocuments ? 0 : -1,
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.swapTable`)), 9, _hoisted_77),
              _createElementVNode("a", {
                href: _ctx.$t(`${_ctx.TRANSLATION_KEY}.exAnteFileCfds`),
                rel: "noopener",
                target: "_blank"
              }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.exAnteCfds`)), 9, _hoisted_78)
            ], 2)),
        _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.informationAboutSendingDocuments`
                        )), 1)
      ], 2),
      _createVNode(_component_SubmitButton, {
        action: _ctx.Action.DECLARATION_ACCEPTANCE,
        "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
        data: _ctx.formData,
        "data-testid": "btn-declarationAcceptance-nextStep",
        class: "button button--submit",
        disabled: _ctx.formIsValid || _ctx.formEsgFailedValid,
        onClick: _ctx.handleNextStep
      }, null, 8, ["action", "button-value", "data", "disabled", "onClick"])
    ], 44, _hoisted_11)
  ]))
}